module.exports = __webpack_public_path__ + "static/Playstore-388ab38c366aaf5dfbcc9199804cd0a0.png";